module.exports = global["application_survey_assessment"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./assessment.ts");